/** Source-backed local media inventory. Generated; do not use analysis/ paths at runtime. */

export const heroMedia = [
  {
    "id": "hero-desktop",
    "path": "/media/hero/hero-desktop",
    "sourcePath": "analysis/media/other/hero-desk.png",
    "width": 1672,
    "height": 941,
    "focalPoint": "center",
    "alt": "Immagine di apertura Esamed",
    "license": "not-verified; supplied source for local migration only",
    "formats": [
      "avif",
      "webp",
      "png"
    ]
  },
  {
    "id": "hero-mobile",
    "path": "/media/hero/hero-mobile",
    "sourcePath": "analysis/media/other/hero-mobile.png",
    "width": 941,
    "height": 1672,
    "focalPoint": "center",
    "alt": "Immagine di apertura Esamed",
    "license": "not-verified; supplied source for local migration only",
    "formats": [
      "avif",
      "webp",
      "png"
    ]
  }
] as const;

export const sourceMedia = [
  {
    "path": "/media/source/certificates/cert-13485.png",
    "sourcePath": "analysis/media/certificates/cert-13485.png",
    "width": 300,
    "height": 225,
    "bytes": 46083,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/certificates/cert-9001.png",
    "sourcePath": "analysis/media/certificates/cert-9001.png",
    "width": 300,
    "height": 225,
    "bytes": 45904,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/1_proc-155x300.jpg",
    "sourcePath": "analysis/media/images/1_proc-155x300.jpg",
    "width": 155,
    "height": 300,
    "bytes": 6392,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/1_proc.jpg",
    "sourcePath": "analysis/media/images/1_proc.jpg",
    "width": 170,
    "height": 329,
    "bytes": 10410,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/1-1152x768.jpg",
    "sourcePath": "analysis/media/images/1-1152x768.jpg",
    "width": 1152,
    "height": 768,
    "bytes": 119715,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/1-768x512.jpg",
    "sourcePath": "analysis/media/images/1-768x512.jpg",
    "width": 768,
    "height": 512,
    "bytes": 68371,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/1-Esatrace-check-out.jpg",
    "sourcePath": "analysis/media/images/1-Esatrace-check-out.jpg",
    "width": 1000,
    "height": 703,
    "bytes": 427015,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/"
    ],
    "stableIds": [
      "prd-esatrace"
    ]
  },
  {
    "path": "/media/source/images/1.jpg",
    "sourcePath": "analysis/media/images/1.jpg",
    "width": 1748,
    "height": 1240,
    "bytes": 246697,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/simti-2026-workshop-esamed/"
    ],
    "stableIds": [
      "news-simti-2026-workshop-esamed"
    ]
  },
  {
    "path": "/media/source/images/2_proc-271x300.jpg",
    "sourcePath": "analysis/media/images/2_proc-271x300.jpg",
    "width": 271,
    "height": 300,
    "bytes": 12568,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/2_proc.jpg",
    "sourcePath": "analysis/media/images/2_proc.jpg",
    "width": 296,
    "height": 328,
    "bytes": 19759,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/2-Esatrace-check-in.jpg",
    "sourcePath": "analysis/media/images/2-Esatrace-check-in.jpg",
    "width": 1000,
    "height": 703,
    "bytes": 297157,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/"
    ],
    "stableIds": [
      "prd-esatrace"
    ]
  },
  {
    "path": "/media/source/images/2.jpg",
    "sourcePath": "analysis/media/images/2.jpg",
    "width": 1748,
    "height": 1240,
    "bytes": 228996,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/esamed-workshop-simti-2026/",
      "https://www.esamed.it/simti-2026-workshop-esamed/"
    ],
    "stableIds": [
      "news-simti-2026-workshop-esamed"
    ]
  },
  {
    "path": "/media/source/images/2022_MEDICA_2375x500_150-scaled.jpg",
    "sourcePath": "analysis/media/images/2022_MEDICA_2375x500_150-scaled.jpg",
    "width": 2560,
    "height": 539,
    "bytes": 165810,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medica-2022/",
      "https://www.esamed.it/medica-2022/"
    ],
    "stableIds": [
      "news-medica-2022"
    ]
  },
  {
    "path": "/media/source/images/3_proc-300x188.png",
    "sourcePath": "analysis/media/images/3_proc-300x188.png",
    "width": 300,
    "height": 188,
    "bytes": 20766,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/3_proc.png",
    "sourcePath": "analysis/media/images/3_proc.png",
    "width": 460,
    "height": 289,
    "bytes": 30977,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/3-Esatrace-esito.jpg",
    "sourcePath": "analysis/media/images/3-Esatrace-esito.jpg",
    "width": 1000,
    "height": 703,
    "bytes": 204435,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/"
    ],
    "stableIds": [
      "prd-esatrace"
    ]
  },
  {
    "path": "/media/source/images/350-tabella.png",
    "sourcePath": "analysis/media/images/350-tabella.png",
    "width": 668,
    "height": 465,
    "bytes": 68647,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-domel-centric-350/"
    ],
    "stableIds": [
      "prd-centrifuga-domel-centric-350"
    ]
  },
  {
    "path": "/media/source/images/4-Esatrace-monitoraggio-missioni.jpg",
    "sourcePath": "analysis/media/images/4-Esatrace-monitoraggio-missioni.jpg",
    "width": 1000,
    "height": 703,
    "bytes": 206040,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/"
    ],
    "stableIds": [
      "prd-esatrace"
    ]
  },
  {
    "path": "/media/source/images/48-48R-tabella.png",
    "sourcePath": "analysis/media/images/48-48R-tabella.png",
    "width": 675,
    "height": 460,
    "bytes": 70785,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-mf48-48r-domel/"
    ],
    "stableIds": [
      "prd-centrifuga-mf48-48r-domel"
    ]
  },
  {
    "path": "/media/source/images/5-cAOYiDRSiwZ9rWETN1nQ.jpg",
    "sourcePath": "analysis/media/images/5-cAOYiDRSiwZ9rWETN1nQ.jpg",
    "width": 1500,
    "height": 458,
    "bytes": 116837,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/accessori-prelievo-1.png",
    "sourcePath": "analysis/media/images/accessori-prelievo-1.png",
    "width": 500,
    "height": 300,
    "bytes": 27892,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/sistemi-di-prelievo/accessori_prelievo/"
    ],
    "stableIds": [
      "prd-accessori-prelievo"
    ]
  },
  {
    "path": "/media/source/images/Accessori-secondari-Esamed.png",
    "sourcePath": "analysis/media/images/Accessori-secondari-Esamed.png",
    "width": 200,
    "height": 200,
    "bytes": 11655,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/accessories-for-bios/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/"
    ],
    "stableIds": [
      "prd-accessori-contenitore-secondario-bios"
    ]
  },
  {
    "path": "/media/source/images/Accessori-terziari-esamed-1.png",
    "sourcePath": "analysis/media/images/Accessori-terziari-esamed-1.png",
    "width": 300,
    "height": 300,
    "bytes": 35790,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/cooling-plates/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari/"
    ],
    "stableIds": [
      "prd-piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari"
    ]
  },
  {
    "path": "/media/source/images/ACCRE8-2.png",
    "sourcePath": "analysis/media/images/ACCRE8-2.png",
    "width": 300,
    "height": 300,
    "bytes": 34164,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/accre8-immunometria/"
    ],
    "stableIds": [
      "prd-accre8-immunometria"
    ]
  },
  {
    "path": "/media/source/images/AF-300.png",
    "sourcePath": "analysis/media/images/AF-300.png",
    "width": 300,
    "height": 300,
    "bytes": 24985,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-af-300/"
    ],
    "stableIds": [
      "prd-mindray-af-300"
    ]
  },
  {
    "path": "/media/source/images/AMCLI-1.jpeg",
    "sourcePath": "analysis/media/images/AMCLI-1.jpeg",
    "width": 1536,
    "height": 2048,
    "bytes": 234365,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/amcli-2026/",
      "https://www.esamed.it/en/5310/"
    ],
    "stableIds": [
      "news-amcli-2026"
    ]
  },
  {
    "path": "/media/source/images/AMCLI-2.jpeg",
    "sourcePath": "analysis/media/images/AMCLI-2.jpeg",
    "width": 1536,
    "height": 2048,
    "bytes": 224032,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/amcli-2026/",
      "https://www.esamed.it/en/5310/"
    ],
    "stableIds": [
      "news-amcli-2026"
    ]
  },
  {
    "path": "/media/source/images/AMCLI-4.jpeg",
    "sourcePath": "analysis/media/images/AMCLI-4.jpeg",
    "width": 1500,
    "height": 2000,
    "bytes": 215057,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/amcli-2026/",
      "https://www.esamed.it/en/5310/"
    ],
    "stableIds": [
      "news-amcli-2026"
    ]
  },
  {
    "path": "/media/source/images/AMCLI-5-1152x768.jpeg",
    "sourcePath": "analysis/media/images/AMCLI-5-1152x768.jpeg",
    "width": 1152,
    "height": 768,
    "bytes": 118992,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/AMCLI-5-768x512.jpeg",
    "sourcePath": "analysis/media/images/AMCLI-5-768x512.jpeg",
    "width": 768,
    "height": 512,
    "bytes": 65414,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/AMCLI-5.jpeg",
    "sourcePath": "analysis/media/images/AMCLI-5.jpeg",
    "width": 1200,
    "height": 1200,
    "bytes": 160775,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/amcli-2026/",
      "https://www.esamed.it/en/5310/"
    ],
    "stableIds": [
      "news-amcli-2026"
    ]
  },
  {
    "path": "/media/source/images/AP-100.png",
    "sourcePath": "analysis/media/images/AP-100.png",
    "width": 300,
    "height": 300,
    "bytes": 25676,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-af-300/"
    ],
    "stableIds": [
      "prd-mindray-af-300"
    ]
  },
  {
    "path": "/media/source/images/Attrezzatura-da-laboratorio-300x296.png",
    "sourcePath": "analysis/media/images/Attrezzatura-da-laboratorio-300x296.png",
    "width": 300,
    "height": 296,
    "bytes": 17732,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/Attrezzatura-da-laboratorio.png",
    "sourcePath": "analysis/media/images/Attrezzatura-da-laboratorio.png",
    "width": 710,
    "height": 701,
    "bytes": 117056,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/BBRV-3.png",
    "sourcePath": "analysis/media/images/BBRV-3.png",
    "width": 200,
    "height": 200,
    "bytes": 15170,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/"
    ],
    "stableIds": [
      "prd-frigoemoteche-congelatori"
    ]
  },
  {
    "path": "/media/source/images/BG10N.png",
    "sourcePath": "analysis/media/images/BG10N.png",
    "width": 300,
    "height": 300,
    "bytes": 58908,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/sg1/"
    ],
    "stableIds": [
      "prd-sg1"
    ]
  },
  {
    "path": "/media/source/images/BIOS.png",
    "sourcePath": "analysis/media/images/BIOS.png",
    "width": 637,
    "height": 420,
    "bytes": 61580,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-bios-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-bios-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/BLCF-3.png",
    "sourcePath": "analysis/media/images/BLCF-3.png",
    "width": 200,
    "height": 200,
    "bytes": 36127,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/bottiglie-nuove-1.png",
    "sourcePath": "analysis/media/images/bottiglie-nuove-1.png",
    "width": 200,
    "height": 200,
    "bytes": 24349,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/"
    ],
    "stableIds": [
      "prd-mindray-fa-n-series"
    ]
  },
  {
    "path": "/media/source/images/Busta-biosicurezza.png",
    "sourcePath": "analysis/media/images/Busta-biosicurezza.png",
    "width": 838,
    "height": 913,
    "bytes": 71012,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/bag-secondary-containers/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-busta-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-busta-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/Busta.png",
    "sourcePath": "analysis/media/images/Busta.png",
    "width": 653,
    "height": 258,
    "bytes": 36228,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-busta-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-busta-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/c-kup-2.png",
    "sourcePath": "analysis/media/images/c-kup-2.png",
    "width": 300,
    "height": 300,
    "bytes": 15078,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/infertilita/c-kup-bonraybio/"
    ],
    "stableIds": [
      "prd-c-kup-bonraybio"
    ]
  },
  {
    "path": "/media/source/images/CA0CA1-1.png",
    "sourcePath": "analysis/media/images/CA0CA1-1.png",
    "width": 300,
    "height": 300,
    "bytes": 31860,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/infertilita/ca0ca1-bonraybio/"
    ],
    "stableIds": [
      "prd-ca0ca1-bonraybio"
    ]
  },
  {
    "path": "/media/source/images/celle-1.png",
    "sourcePath": "analysis/media/images/celle-1.png",
    "width": 300,
    "height": 300,
    "bytes": 22903,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/celle-frigorifere/"
    ],
    "stableIds": [
      "prd-celle-frigorifere"
    ]
  },
  {
    "path": "/media/source/images/centric-108-GR-1.png",
    "sourcePath": "analysis/media/images/centric-108-GR-1.png",
    "width": 200,
    "height": 200,
    "bytes": 11512,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-centric-cf-108r-gr/"
    ],
    "stableIds": [
      "prd-centrifuga-centric-cf-108r-gr"
    ]
  },
  {
    "path": "/media/source/images/centric-108-R-1.png",
    "sourcePath": "analysis/media/images/centric-108-R-1.png",
    "width": 200,
    "height": 200,
    "bytes": 10044,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-centric-cf-108r-gr/"
    ],
    "stableIds": [
      "prd-centrifuga-centric-cf-108r-gr"
    ]
  },
  {
    "path": "/media/source/images/centric-108-R-GR-1.png",
    "sourcePath": "analysis/media/images/centric-108-R-GR-1.png",
    "width": 300,
    "height": 300,
    "bytes": 22086,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-centric-cf-108r-gr/"
    ],
    "stableIds": [
      "prd-centrifuga-centric-cf-108r-gr"
    ]
  },
  {
    "path": "/media/source/images/centrifuga-350-1.png",
    "sourcePath": "analysis/media/images/centrifuga-350-1.png",
    "width": 300,
    "height": 300,
    "bytes": 28573,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/centrifuga-domel-mf48/",
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-domel-centric-350/"
    ],
    "stableIds": [
      "prd-centrifuga-domel-centric-350",
      "prd-centrifuga-mf48-48r-domel"
    ]
  },
  {
    "path": "/media/source/images/centrifuga-MF48-48R.png",
    "sourcePath": "analysis/media/images/centrifuga-MF48-48R.png",
    "width": 300,
    "height": 300,
    "bytes": 27335,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-mf48-48r-domel/"
    ],
    "stableIds": [
      "prd-centrifuga-mf48-48r-domel"
    ]
  },
  {
    "path": "/media/source/images/cong1.png",
    "sourcePath": "analysis/media/images/cong1.png",
    "width": 792,
    "height": 847,
    "bytes": 218433,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/convegno-poct-udine/",
      "https://www.esamed.it/en/",
      "https://www.esamed.it/en/poct-conference-in-udine/"
    ],
    "stableIds": [
      "news-convegno-poct-udine",
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/cong2.png",
    "sourcePath": "analysis/media/images/cong2.png",
    "width": 770,
    "height": 846,
    "bytes": 349654,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/convegno-poct-udine/",
      "https://www.esamed.it/en/",
      "https://www.esamed.it/en/poct-conference-in-udine/"
    ],
    "stableIds": [
      "news-convegno-poct-udine",
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/cong3.png",
    "sourcePath": "analysis/media/images/cong3.png",
    "width": 766,
    "height": 835,
    "bytes": 180881,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/convegno-poct-udine/",
      "https://www.esamed.it/en/",
      "https://www.esamed.it/en/poct-conference-in-udine/"
    ],
    "stableIds": [
      "news-convegno-poct-udine",
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/congelatori-da-laboratorio.png",
    "sourcePath": "analysis/media/images/congelatori-da-laboratorio.png",
    "width": 642,
    "height": 689,
    "bytes": 99190,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/Contenitore-secondario-kartell-1.png",
    "sourcePath": "analysis/media/images/Contenitore-secondario-kartell-1.png",
    "width": 300,
    "height": 300,
    "bytes": 30495,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-kartell-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-kartell-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/contenitori-terziari-a-basso-spessore-1.png",
    "sourcePath": "analysis/media/images/contenitori-terziari-a-basso-spessore-1.png",
    "width": 300,
    "height": 300,
    "bytes": 18078,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/slimline-tertiary-containers/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed/"
    ],
    "stableIds": [
      "prd-contenitore-terziario-a-basso-spessore-samed"
    ]
  },
  {
    "path": "/media/source/images/Contenitori-terziari-Esamed-1.png",
    "sourcePath": "analysis/media/images/Contenitori-terziari-Esamed-1.png",
    "width": 300,
    "height": 300,
    "bytes": 41723,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed"
    ]
  },
  {
    "path": "/media/source/images/cpa_4.png",
    "sourcePath": "analysis/media/images/cpa_4.png",
    "width": 549,
    "height": 467,
    "bytes": 172228,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/cpa-easynat-real-time-molecular-diagnostic-system/",
      "https://www.esamed.it/en/cpa-easynat-real-time-molecular-diagnostic-system/",
      "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/"
    ],
    "stableIds": [
      "news-cpa-easynat-real-time-molecular-diagnostic-system",
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/CPA-workflow-1-scaled.png",
    "sourcePath": "analysis/media/images/CPA-workflow-1-scaled.png",
    "width": 2560,
    "height": 975,
    "bytes": 129346,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/DATALOGGER.png",
    "sourcePath": "analysis/media/images/DATALOGGER.png",
    "width": 1890,
    "height": 1417,
    "bytes": 376587,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/"
    ],
    "stableIds": [
      "prd-esatrace"
    ]
  },
  {
    "path": "/media/source/images/DC2000SL-1.png",
    "sourcePath": "analysis/media/images/DC2000SL-1.png",
    "width": 300,
    "height": 500,
    "bytes": 36625,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/dc-2000-sl-stappatore/",
      "https://www.esamed.it/prodotti/preanalitica/dc-2000-sl-stappatore/"
    ],
    "stableIds": [
      "prd-dc-2000-sl-stappatore"
    ]
  },
  {
    "path": "/media/source/images/decapper-1-768x512.jpg",
    "sourcePath": "analysis/media/images/decapper-1-768x512.jpg",
    "width": 768,
    "height": 512,
    "bytes": 39080,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/decapper-1-863x575.jpg",
    "sourcePath": "analysis/media/images/decapper-1-863x575.jpg",
    "width": 863,
    "height": 575,
    "bytes": 49768,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/decapper-1.jpg",
    "sourcePath": "analysis/media/images/decapper-1.jpg",
    "width": 863,
    "height": 734,
    "bytes": 101961,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/new-preanalytics-products-detapper-and-recapper/",
      "https://www.esamed.it/nuovi-prodotti-di-preanalitica-decapper-e-recapper/"
    ],
    "stableIds": [
      "news-nuovi-prodotti-di-preanalitica-decapper-e-recapper"
    ]
  },
  {
    "path": "/media/source/images/Easynat-kit.png",
    "sourcePath": "analysis/media/images/Easynat-kit.png",
    "width": 300,
    "height": 300,
    "bytes": 15692,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/Easynat.png",
    "sourcePath": "analysis/media/images/Easynat.png",
    "width": 300,
    "height": 300,
    "bytes": 13214,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/EMOtrace-1.png",
    "sourcePath": "analysis/media/images/EMOtrace-1.png",
    "width": 1890,
    "height": 1417,
    "bytes": 57796,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/EMOtrace-2.png",
    "sourcePath": "analysis/media/images/EMOtrace-2.png",
    "width": 400,
    "height": 360,
    "bytes": 47453,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/traceability/emotrace/",
      "https://www.esamed.it/prodotti/tracciabilita/emotrace-tracciabilita-sangue/"
    ],
    "stableIds": [
      "prd-emotrace-tracciabilita-sangue"
    ]
  },
  {
    "path": "/media/source/images/emotrace-scaled-e1775747461105.png",
    "sourcePath": "analysis/media/images/emotrace-scaled-e1775747461105.png",
    "width": 780,
    "height": 806,
    "bytes": 292517,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/traceability/emotrace/",
      "https://www.esamed.it/prodotti/tracciabilita/emotrace-tracciabilita-sangue/"
    ],
    "stableIds": [
      "prd-emotrace-tracciabilita-sangue"
    ]
  },
  {
    "path": "/media/source/images/EPRF-C-1.png",
    "sourcePath": "analysis/media/images/EPRF-C-1.png",
    "width": 200,
    "height": 200,
    "bytes": 18204,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili/"
    ],
    "stableIds": [
      "prd-frigoriferi-congelatori-portatili"
    ]
  },
  {
    "path": "/media/source/images/EPRF-HC-1.png",
    "sourcePath": "analysis/media/images/EPRF-HC-1.png",
    "width": 200,
    "height": 200,
    "bytes": 17440,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili/"
    ],
    "stableIds": [
      "prd-frigoriferi-congelatori-portatili"
    ]
  },
  {
    "path": "/media/source/images/ES-BIO-2.png",
    "sourcePath": "analysis/media/images/ES-BIO-2.png",
    "width": 200,
    "height": 200,
    "bytes": 48195,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed"
    ]
  },
  {
    "path": "/media/source/images/ES-BIO-M.png",
    "sourcePath": "analysis/media/images/ES-BIO-M.png",
    "width": 492,
    "height": 492,
    "bytes": 118102,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/tertiary-container-esamed-endmed/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed-endmed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed-endmed"
    ]
  },
  {
    "path": "/media/source/images/ES-BIOS-L.png",
    "sourcePath": "analysis/media/images/ES-BIOS-L.png",
    "width": 200,
    "height": 200,
    "bytes": 9636,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/bios/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-bios-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-bios-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/ES-BIOS-M.png",
    "sourcePath": "analysis/media/images/ES-BIOS-M.png",
    "width": 200,
    "height": 200,
    "bytes": 40475,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-bios-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-bios-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/ES-E-BIO-3.png",
    "sourcePath": "analysis/media/images/ES-E-BIO-3.png",
    "width": 200,
    "height": 200,
    "bytes": 38011,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/slimline-tertiary-containers/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed/"
    ],
    "stableIds": [
      "prd-contenitore-terziario-a-basso-spessore-samed"
    ]
  },
  {
    "path": "/media/source/images/ES-E-EMO-2.png",
    "sourcePath": "analysis/media/images/ES-E-EMO-2.png",
    "width": 200,
    "height": 200,
    "bytes": 14756,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/slimline-tertiary-containers/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed/"
    ],
    "stableIds": [
      "prd-contenitore-terziario-a-basso-spessore-samed"
    ]
  },
  {
    "path": "/media/source/images/ES-E-FAB-2.png",
    "sourcePath": "analysis/media/images/ES-E-FAB-2.png",
    "width": 200,
    "height": 200,
    "bytes": 35491,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/slimline-tertiary-containers/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed/"
    ],
    "stableIds": [
      "prd-contenitore-terziario-a-basso-spessore-samed"
    ]
  },
  {
    "path": "/media/source/images/ES-EMO-2.png",
    "sourcePath": "analysis/media/images/ES-EMO-2.png",
    "width": 200,
    "height": 200,
    "bytes": 54516,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed"
    ]
  },
  {
    "path": "/media/source/images/ES-FAB-2.png",
    "sourcePath": "analysis/media/images/ES-FAB-2.png",
    "width": 200,
    "height": 200,
    "bytes": 47227,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed"
    ]
  },
  {
    "path": "/media/source/images/ES-GEN-1.png",
    "sourcePath": "analysis/media/images/ES-GEN-1.png",
    "width": 200,
    "height": 200,
    "bytes": 47408,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed"
    ]
  },
  {
    "path": "/media/source/images/ES-SP18.png",
    "sourcePath": "analysis/media/images/ES-SP18.png",
    "width": 200,
    "height": 200,
    "bytes": 14825,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/"
    ],
    "stableIds": [
      "prd-accessori-contenitore-secondario-bios"
    ]
  },
  {
    "path": "/media/source/images/ES-SP78.png",
    "sourcePath": "analysis/media/images/ES-SP78.png",
    "width": 200,
    "height": 200,
    "bytes": 13410,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/"
    ],
    "stableIds": [
      "prd-accessori-contenitore-secondario-bios"
    ]
  },
  {
    "path": "/media/source/images/ESAliva.png",
    "sourcePath": "analysis/media/images/ESAliva.png",
    "width": 500,
    "height": 300,
    "bytes": 15151,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/collection-systems/esaliva-saliva-collection-device/",
      "https://www.esamed.it/prodotti/sistemi-di-prelievo/esaliva-dispositivo-per-la-raccolta-della-saliva/"
    ],
    "stableIds": [
      "prd-esaliva-dispositivo-per-la-raccolta-della-saliva"
    ]
  },
  {
    "path": "/media/source/images/Esamed_2026-1200x750.jpeg",
    "sourcePath": "analysis/media/images/Esamed_2026-1200x750.jpeg",
    "width": 1200,
    "height": 750,
    "bytes": 172780,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/chi-siamo/"
    ],
    "stableIds": [
      "page-company"
    ]
  },
  {
    "path": "/media/source/images/Esamed_2026.jpeg",
    "sourcePath": "analysis/media/images/Esamed_2026.jpeg",
    "width": 1200,
    "height": 1600,
    "bytes": 312278,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/esamed_scivac-5.png",
    "sourcePath": "analysis/media/images/esamed_scivac-5.png",
    "width": 1437,
    "height": 1080,
    "bytes": 729924,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/scivac-rimini-2022/",
      "https://www.esamed.it/scivac-rimini-2022/"
    ],
    "stableIds": [
      "news-scivac-rimini-2022"
    ]
  },
  {
    "path": "/media/source/images/ESAPoct-1.png",
    "sourcePath": "analysis/media/images/ESAPoct-1.png",
    "width": 339,
    "height": 272,
    "bytes": 41759,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/tracciabilita/esapoct-gestione-poct/"
    ],
    "stableIds": [
      "prd-esapoct-gestione-poct"
    ]
  },
  {
    "path": "/media/source/images/ESApoct-software-e1775749250164.png",
    "sourcePath": "analysis/media/images/ESApoct-software-e1775749250164.png",
    "width": 760,
    "height": 870,
    "bytes": 30273,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/tracciabilita/esapoct-gestione-poct/"
    ],
    "stableIds": [
      "prd-esapoct-gestione-poct"
    ]
  },
  {
    "path": "/media/source/images/Eugenio-1940-scaled.jpg",
    "sourcePath": "analysis/media/images/Eugenio-1940-scaled.jpg",
    "width": 2560,
    "height": 1707,
    "bytes": 480110,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/eugenio/",
      "https://www.esamed.it/en/products/transport-systems/eugenio-2/",
      "https://www.esamed.it/prodotti/preanalitica/eugenio/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/eugenio-esamed/"
    ],
    "stableIds": [
      "prd-eugenio",
      "prd-eugenio-esamed"
    ]
  },
  {
    "path": "/media/source/images/Eugenio-1974-scaled.jpg",
    "sourcePath": "analysis/media/images/Eugenio-1974-scaled.jpg",
    "width": 2560,
    "height": 1707,
    "bytes": 482380,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/eugenio/",
      "https://www.esamed.it/en/products/transport-systems/eugenio-2/",
      "https://www.esamed.it/prodotti/preanalitica/eugenio/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/eugenio-esamed/"
    ],
    "stableIds": [
      "prd-eugenio",
      "prd-eugenio-esamed"
    ]
  },
  {
    "path": "/media/source/images/Eugenio-Esamed-1.png",
    "sourcePath": "analysis/media/images/Eugenio-Esamed-1.png",
    "width": 500,
    "height": 300,
    "bytes": 52417,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/eugenio/",
      "https://www.esamed.it/en/products/transport-systems/eugenio-2/",
      "https://www.esamed.it/prodotti/preanalitica/eugenio/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/eugenio-esamed/"
    ],
    "stableIds": [
      "prd-eugenio",
      "prd-eugenio-esamed"
    ]
  },
  {
    "path": "/media/source/images/EugenioAperto-scaled.jpg",
    "sourcePath": "analysis/media/images/EugenioAperto-scaled.jpg",
    "width": 2560,
    "height": 1810,
    "bytes": 344855,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/eugenio/",
      "https://www.esamed.it/en/products/transport-systems/eugenio-2/",
      "https://www.esamed.it/prodotti/preanalitica/eugenio/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/eugenio-esamed/"
    ],
    "stableIds": [
      "prd-eugenio",
      "prd-eugenio-esamed"
    ]
  },
  {
    "path": "/media/source/images/FA-N-series-1.png",
    "sourcePath": "analysis/media/images/FA-N-series-1.png",
    "width": 300,
    "height": 300,
    "bytes": 23370,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/"
    ],
    "stableIds": [
      "prd-mindray-fa-n-series"
    ]
  },
  {
    "path": "/media/source/images/FA-N120-2.png",
    "sourcePath": "analysis/media/images/FA-N120-2.png",
    "width": 200,
    "height": 200,
    "bytes": 18341,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/"
    ],
    "stableIds": [
      "prd-mindray-fa-n-series"
    ]
  },
  {
    "path": "/media/source/images/FA-N20-1.png",
    "sourcePath": "analysis/media/images/FA-N20-1.png",
    "width": 200,
    "height": 200,
    "bytes": 7989,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/"
    ],
    "stableIds": [
      "prd-mindray-fa-n-series"
    ]
  },
  {
    "path": "/media/source/images/FA-N480-1.png",
    "sourcePath": "analysis/media/images/FA-N480-1.png",
    "width": 200,
    "height": 200,
    "bytes": 17008,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/"
    ],
    "stableIds": [
      "prd-mindray-fa-n-series"
    ]
  },
  {
    "path": "/media/source/images/FA-N60.png",
    "sourcePath": "analysis/media/images/FA-N60.png",
    "width": 200,
    "height": 200,
    "bytes": 10925,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/"
    ],
    "stableIds": [
      "prd-mindray-fa-n-series"
    ]
  },
  {
    "path": "/media/source/images/frigoemoteche-1.png",
    "sourcePath": "analysis/media/images/frigoemoteche-1.png",
    "width": 300,
    "height": 300,
    "bytes": 24764,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/"
    ],
    "stableIds": [
      "prd-frigoemoteche-congelatori"
    ]
  },
  {
    "path": "/media/source/images/frigoriferi-combinati-1.png",
    "sourcePath": "analysis/media/images/frigoriferi-combinati-1.png",
    "width": 300,
    "height": 300,
    "bytes": 32148,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali-a-due-temperature"
    ]
  },
  {
    "path": "/media/source/images/frigoriferi-medicali-evermed-1.png",
    "sourcePath": "analysis/media/images/frigoriferi-medicali-evermed-1.png",
    "width": 300,
    "height": 300,
    "bytes": 26091,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali"
    ]
  },
  {
    "path": "/media/source/images/frigoriferi-portatili-1.png",
    "sourcePath": "analysis/media/images/frigoriferi-portatili-1.png",
    "width": 500,
    "height": 300,
    "bytes": 55696,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili/"
    ],
    "stableIds": [
      "prd-frigoriferi-congelatori-portatili"
    ]
  },
  {
    "path": "/media/source/images/giornale_imm.png",
    "sourcePath": "analysis/media/images/giornale_imm.png",
    "width": 877,
    "height": 1304,
    "bytes": 1056521,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/articolo-de-osservatorio-gruppo24ore/"
    ],
    "stableIds": [
      "news-articolo-de-osservatorio-gruppo24ore"
    ]
  },
  {
    "path": "/media/source/images/home-1.jpg",
    "sourcePath": "analysis/media/images/home-1.jpg",
    "width": 1654,
    "height": 2156,
    "bytes": 2483809,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medica-2022/",
      "https://www.esamed.it/medica-2022/"
    ],
    "stableIds": [
      "news-medica-2022"
    ]
  },
  {
    "path": "/media/source/images/IC-2.png",
    "sourcePath": "analysis/media/images/IC-2.png",
    "width": 200,
    "height": 200,
    "bytes": 10663,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili/"
    ],
    "stableIds": [
      "prd-frigoriferi-congelatori-portatili"
    ]
  },
  {
    "path": "/media/source/images/image_3A1000010895_0x0_1720x2040-1064x1262.png",
    "sourcePath": "analysis/media/images/image_3A1000010895_0x0_1720x2040-1064x1262.png",
    "width": 1064,
    "height": 1262,
    "bytes": 1456078,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image_3A1000010895_0x0_1720x2040-1295x1536.png",
    "sourcePath": "analysis/media/images/image_3A1000010895_0x0_1720x2040-1295x1536.png",
    "width": 1295,
    "height": 1536,
    "bytes": 2052695,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image_3A1000010895_0x0_1720x2040-253x300.png",
    "sourcePath": "analysis/media/images/image_3A1000010895_0x0_1720x2040-253x300.png",
    "width": 253,
    "height": 300,
    "bytes": 110170,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image_3A1000010895_0x0_1720x2040-768x911.png",
    "sourcePath": "analysis/media/images/image_3A1000010895_0x0_1720x2040-768x911.png",
    "width": 768,
    "height": 911,
    "bytes": 806814,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image_3A1000010895_0x0_1720x2040-863x1024.png",
    "sourcePath": "analysis/media/images/image_3A1000010895_0x0_1720x2040-863x1024.png",
    "width": 863,
    "height": 1024,
    "bytes": 998846,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image_3A1000010895_0x0_1720x2040.png",
    "sourcePath": "analysis/media/images/image_3A1000010895_0x0_1720x2040.png",
    "width": 1720,
    "height": 2040,
    "bytes": 3629271,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image001-300x235.png",
    "sourcePath": "analysis/media/images/image001-300x235.png",
    "width": 300,
    "height": 235,
    "bytes": 84209,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image001-768x512.png",
    "sourcePath": "analysis/media/images/image001-768x512.png",
    "width": 768,
    "height": 512,
    "bytes": 445456,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/image001-768x602.png",
    "sourcePath": "analysis/media/images/image001-768x602.png",
    "width": 768,
    "height": 602,
    "bytes": 466487,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/image001-845x563.png",
    "sourcePath": "analysis/media/images/image001-845x563.png",
    "width": 845,
    "height": 563,
    "bytes": 567824,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/image001.png",
    "sourcePath": "analysis/media/images/image001.png",
    "width": 845,
    "height": 662,
    "bytes": 739858,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/medlab-middle-east-2024/",
      "https://www.esamed.it/medlab-middle-east-2024/"
    ],
    "stableIds": [
      "news-medlab-middle-east-2024"
    ]
  },
  {
    "path": "/media/source/images/infertilita-categoria-3-150x150.png",
    "sourcePath": "analysis/media/images/infertilita-categoria-3-150x150.png",
    "width": 150,
    "height": 150,
    "bytes": 6162,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/infertilita-categoria-3-200x200.png",
    "sourcePath": "analysis/media/images/infertilita-categoria-3-200x200.png",
    "width": 200,
    "height": 200,
    "bytes": 9849,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/infertilita-categoria-3.png",
    "sourcePath": "analysis/media/images/infertilita-categoria-3.png",
    "width": 300,
    "height": 300,
    "bytes": 20891,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/kartell.png",
    "sourcePath": "analysis/media/images/kartell.png",
    "width": 626,
    "height": 303,
    "bytes": 35826,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-kartell-campioni-biologici/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-kartell-campioni-biologici"
    ]
  },
  {
    "path": "/media/source/images/laboratorio-esamed.png",
    "sourcePath": "analysis/media/images/laboratorio-esamed.png",
    "width": 1130,
    "height": 734,
    "bytes": 455259,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/LCDF-2.png",
    "sourcePath": "analysis/media/images/LCDF-2.png",
    "width": 200,
    "height": 200,
    "bytes": 16516,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/LCRF-1.png",
    "sourcePath": "analysis/media/images/LCRF-1.png",
    "width": 200,
    "height": 200,
    "bytes": 8755,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali-a-due-temperature"
    ]
  },
  {
    "path": "/media/source/images/LCRR-2.png",
    "sourcePath": "analysis/media/images/LCRR-2.png",
    "width": 200,
    "height": 200,
    "bytes": 18860,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali-a-due-temperature"
    ]
  },
  {
    "path": "/media/source/images/LCSDF-1.png",
    "sourcePath": "analysis/media/images/LCSDF-1.png",
    "width": 200,
    "height": 200,
    "bytes": 13575,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/LDF-1.png",
    "sourcePath": "analysis/media/images/LDF-1.png",
    "width": 200,
    "height": 200,
    "bytes": 7435,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/LDF-MD-1.png",
    "sourcePath": "analysis/media/images/LDF-MD-1.png",
    "width": 200,
    "height": 200,
    "bytes": 9375,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/"
    ],
    "stableIds": [
      "prd-frigoemoteche-congelatori"
    ]
  },
  {
    "path": "/media/source/images/LF-2.png",
    "sourcePath": "analysis/media/images/LF-2.png",
    "width": 200,
    "height": 200,
    "bytes": 8275,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/LF-MD.png",
    "sourcePath": "analysis/media/images/LF-MD.png",
    "width": 200,
    "height": 200,
    "bytes": 8148,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/"
    ],
    "stableIds": [
      "prd-frigoemoteche-congelatori"
    ]
  },
  {
    "path": "/media/source/images/LFG-2.png",
    "sourcePath": "analysis/media/images/LFG-2.png",
    "width": 200,
    "height": 200,
    "bytes": 12029,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/LFG-MD-1.png",
    "sourcePath": "analysis/media/images/LFG-MD-1.png",
    "width": 200,
    "height": 200,
    "bytes": 12661,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/"
    ],
    "stableIds": [
      "prd-frigoemoteche-congelatori"
    ]
  },
  {
    "path": "/media/source/images/Login-new.png",
    "sourcePath": "analysis/media/images/Login-new.png",
    "width": 480,
    "height": 989,
    "bytes": 132967,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/tracciabilita/samtrace-sistema-esamed-per-la-tracciabilita-delle-provette/"
    ],
    "stableIds": [
      "prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette"
    ]
  },
  {
    "path": "/media/source/images/LR-3.png",
    "sourcePath": "analysis/media/images/LR-3.png",
    "width": 200,
    "height": 200,
    "bytes": 7833,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali"
    ]
  },
  {
    "path": "/media/source/images/MFC-2.png",
    "sourcePath": "analysis/media/images/MFC-2.png",
    "width": 200,
    "height": 200,
    "bytes": 17815,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/celle-frigorifere/"
    ],
    "stableIds": [
      "prd-celle-frigorifere"
    ]
  },
  {
    "path": "/media/source/images/microbiologia-categoria-1064x745.png",
    "sourcePath": "analysis/media/images/microbiologia-categoria-1064x745.png",
    "width": 1064,
    "height": 745,
    "bytes": 105063,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/MPR-2.png",
    "sourcePath": "analysis/media/images/MPR-2.png",
    "width": 200,
    "height": 200,
    "bytes": 10294,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali"
    ]
  },
  {
    "path": "/media/source/images/MPRR-2.png",
    "sourcePath": "analysis/media/images/MPRR-2.png",
    "width": 200,
    "height": 200,
    "bytes": 27261,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature/"
    ],
    "stableIds": [
      "prd-frigoriferi-medicali-a-due-temperature"
    ]
  },
  {
    "path": "/media/source/images/MRC-2.png",
    "sourcePath": "analysis/media/images/MRC-2.png",
    "width": 200,
    "height": 200,
    "bytes": 18279,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/celle-frigorifere/"
    ],
    "stableIds": [
      "prd-celle-frigorifere"
    ]
  },
  {
    "path": "/media/source/images/PDF-1.png",
    "sourcePath": "analysis/media/images/PDF-1.png",
    "width": 200,
    "height": 200,
    "bytes": 8716,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/PDF-MD-1.png",
    "sourcePath": "analysis/media/images/PDF-MD-1.png",
    "width": 200,
    "height": 200,
    "bytes": 7852,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/"
    ],
    "stableIds": [
      "prd-frigoemoteche-congelatori"
    ]
  },
  {
    "path": "/media/source/images/piastre_kit.png",
    "sourcePath": "analysis/media/images/piastre_kit.png",
    "width": 300,
    "height": 300,
    "bytes": 25694,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-af-300/"
    ],
    "stableIds": [
      "prd-mindray-af-300"
    ]
  },
  {
    "path": "/media/source/images/Piastre-eutettiche-1.png",
    "sourcePath": "analysis/media/images/Piastre-eutettiche-1.png",
    "width": 200,
    "height": 200,
    "bytes": 37085,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/cooling-plates/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari/"
    ],
    "stableIds": [
      "prd-piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari"
    ]
  },
  {
    "path": "/media/source/images/piastre-refrigeranti.png",
    "sourcePath": "analysis/media/images/piastre-refrigeranti.png",
    "width": 200,
    "height": 200,
    "bytes": 15155,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/cooling-plates/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari/"
    ],
    "stableIds": [
      "prd-piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari"
    ]
  },
  {
    "path": "/media/source/images/plasmapack-esamed.png",
    "sourcePath": "analysis/media/images/plasmapack-esamed.png",
    "width": 651,
    "height": 673,
    "bytes": 144700,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/plasmapack-secondary-container/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-plasmapack/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-plasmapack"
    ]
  },
  {
    "path": "/media/source/images/plasmapack-tabella.png",
    "sourcePath": "analysis/media/images/plasmapack-tabella.png",
    "width": 668,
    "height": 327,
    "bytes": 33214,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-plasmapack/"
    ],
    "stableIds": [
      "prd-contenitore-secondario-plasmapack"
    ]
  },
  {
    "path": "/media/source/images/POCH-100-1.png",
    "sourcePath": "analysis/media/images/POCH-100-1.png",
    "width": 300,
    "height": 300,
    "bytes": 33142,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/poch100i-sysmex/"
    ],
    "stableIds": [
      "prd-poch100i-sysmex"
    ]
  },
  {
    "path": "/media/source/images/poct_conv-327x218.png",
    "sourcePath": "analysis/media/images/poct_conv-327x218.png",
    "width": 327,
    "height": 218,
    "bytes": 40536,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/poct_conv.png",
    "sourcePath": "analysis/media/images/poct_conv.png",
    "width": 327,
    "height": 271,
    "bytes": 60241,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/convegno-poct-udine/",
      "https://www.esamed.it/en/poct-conference-in-udine/"
    ],
    "stableIds": [
      "news-convegno-poct-udine"
    ]
  },
  {
    "path": "/media/source/images/POCT-categoria-1-150x150.png",
    "sourcePath": "analysis/media/images/POCT-categoria-1-150x150.png",
    "width": 150,
    "height": 150,
    "bytes": 5828,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/POCT-categoria-1-200x200.png",
    "sourcePath": "analysis/media/images/POCT-categoria-1-200x200.png",
    "width": 200,
    "height": 200,
    "bytes": 8805,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/POCT-categoria-1.png",
    "sourcePath": "analysis/media/images/POCT-categoria-1.png",
    "width": 300,
    "height": 300,
    "bytes": 20306,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/preanalitica-categoria-150x150.png",
    "sourcePath": "analysis/media/images/preanalitica-categoria-150x150.png",
    "width": 150,
    "height": 150,
    "bytes": 7172,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/preanalitica-categoria-200x200.png",
    "sourcePath": "analysis/media/images/preanalitica-categoria-200x200.png",
    "width": 200,
    "height": 200,
    "bytes": 11658,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/preanalitica-categoria.png",
    "sourcePath": "analysis/media/images/preanalitica-categoria.png",
    "width": 300,
    "height": 300,
    "bytes": 25319,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/Prelievo-esamed-categoria-1-300x180.png",
    "sourcePath": "analysis/media/images/Prelievo-esamed-categoria-1-300x180.png",
    "width": 300,
    "height": 180,
    "bytes": 12815,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/Prelievo-esamed-categoria-1.png",
    "sourcePath": "analysis/media/images/Prelievo-esamed-categoria-1.png",
    "width": 500,
    "height": 300,
    "bytes": 27524,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/PRF-1.png",
    "sourcePath": "analysis/media/images/PRF-1.png",
    "width": 200,
    "height": 200,
    "bytes": 16895,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili/"
    ],
    "stableIds": [
      "prd-frigoriferi-congelatori-portatili"
    ]
  },
  {
    "path": "/media/source/images/produzione-trasporti-tracciabilita-esamed-2-822x514.png",
    "sourcePath": "analysis/media/images/produzione-trasporti-tracciabilita-esamed-2-822x514.png",
    "width": 822,
    "height": 514,
    "bytes": 258391,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/chi-siamo/"
    ],
    "stableIds": [
      "page-company"
    ]
  },
  {
    "path": "/media/source/images/ProvetteBD-Rack-3.png",
    "sourcePath": "analysis/media/images/ProvetteBD-Rack-3.png",
    "width": 500,
    "height": 300,
    "bytes": 54505,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/sistemi-di-prelievo/provette-bd/"
    ],
    "stableIds": [
      "prd-provette-bd"
    ]
  },
  {
    "path": "/media/source/images/ProvetteBD.png",
    "sourcePath": "analysis/media/images/ProvetteBD.png",
    "width": 358,
    "height": 349,
    "bytes": 19973,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/sistemi-di-prelievo/provette-bd/"
    ],
    "stableIds": [
      "prd-provette-bd"
    ]
  },
  {
    "path": "/media/source/images/pudu-smanno-1.png",
    "sourcePath": "analysis/media/images/pudu-smanno-1.png",
    "width": 300,
    "height": 500,
    "bytes": 72416,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/preanalitica/flashbot_pudu_smanno_camminatore/"
    ],
    "stableIds": [
      "prd-flashbot-pudu-smanno-camminatore"
    ]
  },
  {
    "path": "/media/source/images/R10-1.png",
    "sourcePath": "analysis/media/images/R10-1.png",
    "width": 300,
    "height": 300,
    "bytes": 26394,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/infertilita/r10-bonraybio/"
    ],
    "stableIds": [
      "prd-r10-bonraybio"
    ]
  },
  {
    "path": "/media/source/images/R11-1.png",
    "sourcePath": "analysis/media/images/R11-1.png",
    "width": 300,
    "height": 300,
    "bytes": 23294,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/infertilita/r11-plus-bonraybio/"
    ],
    "stableIds": [
      "prd-r11-plus-bonraybio"
    ]
  },
  {
    "path": "/media/source/images/Rack-bianco-2.png",
    "sourcePath": "analysis/media/images/Rack-bianco-2.png",
    "width": 300,
    "height": 200,
    "bytes": 24180,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/"
    ],
    "stableIds": [
      "prd-accessori-contenitore-secondario-bios"
    ]
  },
  {
    "path": "/media/source/images/rack-esamed-1.png",
    "sourcePath": "analysis/media/images/rack-esamed-1.png",
    "width": 500,
    "height": 300,
    "bytes": 48010,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/preanalitica/portaprovette/"
    ],
    "stableIds": [
      "prd-portaprovette"
    ]
  },
  {
    "path": "/media/source/images/rack-rosso-3.png",
    "sourcePath": "analysis/media/images/rack-rosso-3.png",
    "width": 300,
    "height": 200,
    "bytes": 23649,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/preanalitica/portaprovette/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/"
    ],
    "stableIds": [
      "prd-accessori-contenitore-secondario-bios",
      "prd-portaprovette"
    ]
  },
  {
    "path": "/media/source/images/SAMtrace.png",
    "sourcePath": "analysis/media/images/SAMtrace.png",
    "width": 356,
    "height": 350,
    "bytes": 49212,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/tracciabilita/samtrace-sistema-esamed-per-la-tracciabilita-delle-provette/"
    ],
    "stableIds": [
      "prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette"
    ]
  },
  {
    "path": "/media/source/images/SD1-1.png",
    "sourcePath": "analysis/media/images/SD1-1.png",
    "width": 300,
    "height": 300,
    "bytes": 36007,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/analizzatore-biochimico-a-secco-automatico-sd1/"
    ],
    "stableIds": [
      "prd-analizzatore-biochimico-a-secco-automatico-sd1"
    ]
  },
  {
    "path": "/media/source/images/semen1-1.png",
    "sourcePath": "analysis/media/images/semen1-1.png",
    "width": 579,
    "height": 420,
    "bytes": 125164,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/x1-pro-se-semen-quality-analyzer/"
    ],
    "stableIds": [
      "prd-x1-pro-se-semen-quality-analyzer"
    ]
  },
  {
    "path": "/media/source/images/semen3.jpg",
    "sourcePath": "analysis/media/images/semen3.jpg",
    "width": 2083,
    "height": 1157,
    "bytes": 823063,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/x1-pro-se-semen-quality-analyzer/"
    ],
    "stableIds": [
      "prd-x1-pro-se-semen-quality-analyzer"
    ]
  },
  {
    "path": "/media/source/images/semen4.jpg",
    "sourcePath": "analysis/media/images/semen4.jpg",
    "width": 2082,
    "height": 989,
    "bytes": 367965,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/x1-pro-se-semen-quality-analyzer/"
    ],
    "stableIds": [
      "prd-x1-pro-se-semen-quality-analyzer"
    ]
  },
  {
    "path": "/media/source/images/SG1-2.png",
    "sourcePath": "analysis/media/images/SG1-2.png",
    "width": 300,
    "height": 300,
    "bytes": 16149,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/sg1/"
    ],
    "stableIds": [
      "prd-sg1"
    ]
  },
  {
    "path": "/media/source/images/SIMTI-2026-499x333.png",
    "sourcePath": "analysis/media/images/SIMTI-2026-499x333.png",
    "width": 499,
    "height": 333,
    "bytes": 80154,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/SIMTI-2026.png",
    "sourcePath": "analysis/media/images/SIMTI-2026.png",
    "width": 553,
    "height": 333,
    "bytes": 95537,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/5312/",
      "https://www.esamed.it/simti-2026/"
    ],
    "stableIds": [
      "news-simti-2026"
    ]
  },
  {
    "path": "/media/source/images/sistema-AF-1.png",
    "sourcePath": "analysis/media/images/sistema-AF-1.png",
    "width": 300,
    "height": 300,
    "bytes": 14017,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/microbiologia/mindray-af-300/"
    ],
    "stableIds": [
      "prd-mindray-af-300"
    ]
  },
  {
    "path": "/media/source/images/slide2.jpg",
    "sourcePath": "analysis/media/images/slide2.jpg",
    "width": 2000,
    "height": 1145,
    "bytes": 136550,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/soluzioni-trasporto-Esamed-300x195.png",
    "sourcePath": "analysis/media/images/soluzioni-trasporto-Esamed-300x195.png",
    "width": 300,
    "height": 195,
    "bytes": 17167,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/soluzioni-trasporto-Esamed.png",
    "sourcePath": "analysis/media/images/soluzioni-trasporto-Esamed.png",
    "width": 700,
    "height": 456,
    "bytes": 87805,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/standd.jpeg",
    "sourcePath": "analysis/media/images/standd.jpeg",
    "width": 1600,
    "height": 900,
    "bytes": 107500,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/our-stand-at-the-scivac-rimini/",
      "https://www.esamed.it/il-nostro-stand-scivac-rimini/"
    ],
    "stableIds": [
      "news-il-nostro-stand-scivac-rimini"
    ]
  },
  {
    "path": "/media/source/images/standdd.jpeg",
    "sourcePath": "analysis/media/images/standdd.jpeg",
    "width": 720,
    "height": 1150,
    "bytes": 132563,
    "extension": "jpeg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/our-stand-at-the-scivac-rimini/",
      "https://www.esamed.it/il-nostro-stand-scivac-rimini/"
    ],
    "stableIds": [
      "news-il-nostro-stand-scivac-rimini"
    ]
  },
  {
    "path": "/media/source/images/tabella-basso-spessore.png",
    "sourcePath": "analysis/media/images/tabella-basso-spessore.png",
    "width": 592,
    "height": 262,
    "bytes": 27857,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed/"
    ],
    "stableIds": [
      "prd-contenitore-terziario-a-basso-spessore-samed"
    ]
  },
  {
    "path": "/media/source/images/Tabella-SD1.png",
    "sourcePath": "analysis/media/images/Tabella-SD1.png",
    "width": 662,
    "height": 692,
    "bytes": 121294,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/analizzatore-biochimico-a-secco-automatico-sd1/"
    ],
    "stableIds": [
      "prd-analizzatore-biochimico-a-secco-automatico-sd1"
    ]
  },
  {
    "path": "/media/source/images/telini-1.png",
    "sourcePath": "analysis/media/images/telini-1.png",
    "width": 200,
    "height": 200,
    "bytes": 14786,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/"
    ],
    "stableIds": [
      "prd-accessori-contenitore-secondario-bios"
    ]
  },
  {
    "path": "/media/source/images/test-CPA.png",
    "sourcePath": "analysis/media/images/test-CPA.png",
    "width": 662,
    "height": 505,
    "bytes": 74839,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet/"
    ],
    "stableIds": [
      "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet"
    ]
  },
  {
    "path": "/media/source/images/TIPOS-1.png",
    "sourcePath": "analysis/media/images/TIPOS-1.png",
    "width": 500,
    "height": 300,
    "bytes": 41128,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/preanalitica/tipos-olpaso/"
    ],
    "stableIds": [
      "prd-tipos-olpaso"
    ]
  },
  {
    "path": "/media/source/images/Tracciabilita-Esamed-150x150.png",
    "sourcePath": "analysis/media/images/Tracciabilita-Esamed-150x150.png",
    "width": 150,
    "height": 150,
    "bytes": 11580,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/Tracciabilita-Esamed-200x200.png",
    "sourcePath": "analysis/media/images/Tracciabilita-Esamed-200x200.png",
    "width": 200,
    "height": 200,
    "bytes": 19265,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/Tracciabilita-Esamed.png",
    "sourcePath": "analysis/media/images/Tracciabilita-Esamed.png",
    "width": 300,
    "height": 300,
    "bytes": 37934,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/soluzioni-per-il-laboratorio/"
    ],
    "stableIds": [
      "page-solutions"
    ]
  },
  {
    "path": "/media/source/images/trasporti-esamed.png",
    "sourcePath": "analysis/media/images/trasporti-esamed.png",
    "width": 1890,
    "height": 1417,
    "bytes": 158427,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/",
      "https://www.esamed.it/en/"
    ],
    "stableIds": [
      "page-home"
    ]
  },
  {
    "path": "/media/source/images/trasporti.png",
    "sourcePath": "analysis/media/images/trasporti.png",
    "width": 666,
    "height": 263,
    "bytes": 32229,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/"
    ],
    "stableIds": [
      "prd-contenitori-terziari-esamed"
    ]
  },
  {
    "path": "/media/source/images/TT2000S_IQ.png",
    "sourcePath": "analysis/media/images/TT2000S_IQ.png",
    "width": 500,
    "height": 300,
    "bytes": 47281,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/preanalitica/tt-2000-s-iqvision-endmed/"
    ],
    "stableIds": [
      "prd-tt-2000-s-iqvision-endmed"
    ]
  },
  {
    "path": "/media/source/images/TT2000S.png",
    "sourcePath": "analysis/media/images/TT2000S.png",
    "width": 500,
    "height": 300,
    "bytes": 52935,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/preanalitica/tt-2000-s_endmed/"
    ],
    "stableIds": [
      "prd-tt-2000-s-endmed"
    ]
  },
  {
    "path": "/media/source/images/ULCF-1.png",
    "sourcePath": "analysis/media/images/ULCF-1.png",
    "width": 200,
    "height": 200,
    "bytes": 11899,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/ULF-2.png",
    "sourcePath": "analysis/media/images/ULF-2.png",
    "width": 200,
    "height": 200,
    "bytes": 8411,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/"
    ],
    "stableIds": [
      "prd-congelatori-da-laboratorio"
    ]
  },
  {
    "path": "/media/source/images/X1.e304-en-ver2153_____-12.jpg",
    "sourcePath": "analysis/media/images/X1.e304-en-ver2153_____-12.jpg",
    "width": 2087,
    "height": 636,
    "bytes": 369800,
    "extension": "jpg",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/x1-pro-se-semen-quality-analyzer/"
    ],
    "stableIds": [
      "prd-x1-pro-se-semen-quality-analyzer"
    ]
  },
  {
    "path": "/media/source/images/X12-1.png",
    "sourcePath": "analysis/media/images/X12-1.png",
    "width": 300,
    "height": 300,
    "bytes": 24069,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/sistemi-di-prelievo/x12-pro-semen-analysis-system/",
      "https://www.esamed.it/prodotti/infertilita/x12-pro-semen-analysis-system/"
    ],
    "stableIds": [
      "prd-x12-pro-semen-analysis-system"
    ]
  },
  {
    "path": "/media/source/images/X3-1.png",
    "sourcePath": "analysis/media/images/X3-1.png",
    "width": 300,
    "height": 300,
    "bytes": 27082,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/infertilita/x3-pro-semen-quality-analyzer/"
    ],
    "stableIds": [
      "prd-x3-pro-semen-quality-analyzer"
    ]
  },
  {
    "path": "/media/source/logos/bectondickenson_logo.png",
    "sourcePath": "analysis/media/logos/bectondickenson_logo.png",
    "width": 908,
    "height": 908,
    "bytes": 33308,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/prodotti/sistemi-di-prelievo/provette-bd/"
    ],
    "stableIds": [
      "prd-provette-bd"
    ]
  },
  {
    "path": "/media/source/logos/Logo_Emergency2-1.gif",
    "sourcePath": "analysis/media/logos/Logo_Emergency2-1.gif",
    "width": 490,
    "height": 299,
    "bytes": 13570,
    "extension": "gif",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/poct-emergency-suppliers/",
      "https://www.esamed.it/fornitura-emergency-poct/"
    ],
    "stableIds": [
      "news-fornitura-emergency-poct"
    ]
  },
  {
    "path": "/media/source/logos/Logo-ESAtrace.png",
    "sourcePath": "analysis/media/logos/Logo-ESAtrace.png",
    "width": 340,
    "height": 330,
    "bytes": 47509,
    "extension": "png",
    "focalPoint": "center",
    "alt": null,
    "license": "not-verified; archived source supplied for local migration only",
    "sourceUrls": [
      "https://www.esamed.it/en/products/transport-systems/esatrace/",
      "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/"
    ],
    "stableIds": [
      "prd-esatrace"
    ]
  }
] as const;
